import { render, staticRenderFns } from "./AlertasStockPanel.vue?vue&type=template&id=789bf147&scoped=true&"
import script from "./AlertasStockPanel.vue?vue&type=script&lang=js&"
export * from "./AlertasStockPanel.vue?vue&type=script&lang=js&"
import style0 from "./AlertasStockPanel.vue?vue&type=style&index=0&id=789bf147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789bf147",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VIcon})
